import React from 'react';
import LegalDocumentBody from '../LegalDocumentBody';

type Props = {
    setActiveRightTab?: Function;
};

export default function RiskDisclosureNotice({ setActiveRightTab }: Props) {
    return <LegalDocumentBody titleKey="risk-disclosure-notice" bodyKey="risk-disclosure-notice-body" setActiveRightTab={setActiveRightTab} />;
}
